import * as tags from './tags';
import ControllerClass from './Controller';
import { DEPRECATE } from './utils';
import ModuleClass from './Module';
import UniversalControllerClass from './UniversalController';
var tagsVar = tags;
if (process.env.NODE_ENV !== 'production' && typeof global.Proxy !== 'undefined') {
  tagsVar = Object.keys(tags).reduce(function (proxyHost, key) {
    proxyHost[key] = new Proxy(tags[key], {
      get: function get(obj, prop) {
        throw new Error('YOU HAVE NOT ENABLED THE BABEL-PLUGIN-CEREBRAL');
      }
    });
    return proxyHost;
  }, {});
}
export var props = tagsVar.props;
export var path = tagsVar.path;
export var state = tagsVar.state;
export var string = tagsVar.string;
export var sequences = tagsVar.sequences;
export var computed = tagsVar.computed;
export var moduleState = tagsVar.moduleState;
export var moduleSequences = tagsVar.moduleSequences;
export var moduleComputed = tagsVar.moduleComputed;

// Needed to test for instanceof.
export { default as ModuleClass } from './Module';
export { default as ControllerClass } from './Controller';
export { default as ProviderClass } from './Provider';
export { default as BaseControllerClass } from './BaseController';
export { SequenceFactory as ChainSequenceFactory, SequenceWithPropsFactory as ChainSequenceWithPropsFactory } from 'function-tree/fluent';
export { sequence, parallel, createTemplateTag, extractValueWithPath, resolveObject, ResolveValue, Tag } from 'function-tree';
export function Controller(rootModule, options) {
  DEPRECATE('Controller', 'Use App default import instead');
  return new ControllerClass(rootModule, options);
}
export function UniversalController(rootModule, options) {
  DEPRECATE('UniversalController', 'Use UniversalApp import instead');
  return new UniversalControllerClass(rootModule, options);
}
export function UniversalApp(rootModule, options) {
  return new UniversalControllerClass(rootModule, options);
}
export function Module(definition) {
  DEPRECATE('Module', 'Use plain object/function. Type with ModuleDefinition export');
  return new ModuleClass(definition);
}
export { default as CerebralError } from './CerebralError';
export { default as Provider } from './Provider';
export { default as Compute } from './Compute';
export { default as Reaction } from './Reaction';
export { default as View } from './View';
export { createDummyController, throwError } from './utils';
var existingInstance = void 0;
export default function App(rootModule, options) {
  if (process.env.NODE_ENV === 'development' && existingInstance && (!options || options.hotReloading === undefined)) {
    console.warn('Cerebral has detected HOT RELOADING in your app. It is recommended that you add the option "hotReloading" and set it to true. Set it to false to turn off this message and let it fly');
  }
  if (options && options.hotReloading === true && existingInstance) {
    existingInstance.reconfigure(rootModule);
    return existingInstance;
  }
  return existingInstance = new ControllerClass(rootModule, options);
}